// Author Pan Yu Rou
// Date 2024-12-19 10:41:36

class SithMesPrdZpp1 {
constructor({
        id = null,
        usage = '',
        machineType = '',
        number = '',
        materialNumber = '',
        projectCode = '',
        hasMultipleBoms = '',
        status = '',
        workOrderCode = '',
        materialPropertyVerified = '',
        pricePropertyReviewed = '',
        priceMaintained = '',
        mounted = '',
        routeMaintained = '',
        orderCode = '',
        costEntered = '',
        remark = ''}
= {}) {
    this.id = id;
    this.usage = usage;
    this.machineType = machineType;
    this.number = number;
    this.materialNumber = materialNumber;
    this.projectCode = projectCode;
    this.hasMultipleBoms = hasMultipleBoms;
    this.status = status;
    this.workOrderCode = workOrderCode;
    this.materialPropertyVerified = materialPropertyVerified;
    this.pricePropertyReviewed = pricePropertyReviewed;
    this.priceMaintained = priceMaintained;
    this.mounted = mounted;
    this.routeMaintained = routeMaintained;
    this.orderCode = orderCode;
    this.costEntered = costEntered;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdZpp1();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'usage',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.usage',
        sortable: true,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'zpp1_workflow_usage'
                        }
        },
        {
        key: 'machineType',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.machineType',
        sortable: true,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'zpp1_workflow_machine_type'
                        }
        },
        {
        key: 'number',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.number',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialNumber',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.materialNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialDescription',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.materialDescription',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'hasMultipleBoms',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.hasMultipleBoms',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'workOrderCode',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialPropertyVerified',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.materialPropertyVerified',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'pricePropertyReviewed',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.pricePropertyReviewed',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'priceMaintained',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.priceMaintained',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mounted',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.mounted',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'routeMaintained',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.routeMaintained',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'orderCode',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.orderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'costEntered',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.costEntered',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdTime',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.createdTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.createdByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialPropertyCheckerName',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.materialPropertyCheckerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'pricePropertyCheckerName',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.pricePropertyCheckerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mountCheckerName',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.mountCheckerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'routeMaintainCheckerName',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.routeMaintainCheckerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'orderCodeCreatorName',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.orderCodeCreatorName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'costCheckerName',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.costCheckerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'materialPropertyCheckedTime',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.materialPropertyCheckedTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'pricePropertyCheckedTime',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.pricePropertyCheckedTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mountCheckedTime',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.mountCheckedTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'routeMaintainCheckedTime',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.routeMaintainCheckedTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'orderCodeCreateTime',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.orderCodeCreateTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'costCheckedTime',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.costCheckedTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'statusName',
        label: 'label.sith.prd.sithMesPrdZpp1.grid.statusName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    usageFilter : '',
    machineTypeFilter : '',
    numberFilter : '',
    materialNumberFilter : '',
    materialDescriptionFilter : '',
    projectCodeFilter : '',
    hasMultipleBomsFilter : '',
    statusFilter : '',
    workOrderCodeFilter : '',
    materialPropertyVerifiedFilter : '',
    pricePropertyReviewedFilter : '',
    priceMaintainedFilter : '',
    mountedFilter : '',
    routeMaintainedFilter : '',
    orderCodeFilter : '',
    costEnteredFilter : '',
    createdByNameFilter: '',
    createdTimeRteFilter: '',
    createdTimeLteFilter: '',
    materialPropertyCheckerFilter : '',
    pricePropertyCheckerFilter : '',
    mountCheckerFilter : '',
    routeMaintainCheckerFilter : '',
    orderCodeCreatorFilter : '',
    costCheckerFilter : '',
    materialPropertyCheckedTimeRteFilter : '',
    materialPropertyCheckedTimeLteFilter : '',
    pricePropertyCheckedTimeRteFilter : '',
    pricePropertyCheckedTimeLteFilter : '',
    mountCheckedTimeRteFilter : '',
    mountCheckedTimeLteFilter : '',
    routeMaintainCheckedTimeRteFilter : '',
    routeMaintainCheckedTimeLteFilter : '',
    orderCodeCreateTimeRteFilter : '',
    orderCodeCreateTimeLteFilter : '',
    costCheckedTimeRteFilter : '',
    costCheckedTimeLteFilter : '',
    workflowQueryTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'usageFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.usage',
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'zpp1_workflow_usage'
                }
        },
        {
        key: 'machineTypeFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.machineType',
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            , entity: 'zpp1_workflow_machine_type'
                }
        },
        {
        key: 'numberFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.number',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialNumberFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.materialNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialDescriptionFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.materialDescription',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectCodeFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'hasMultipleBomsFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.hasMultipleBoms',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'SithMesPrdZpp1',statusFilter:1}
        }
        },
        {
        key: 'workOrderCodeFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialPropertyVerifiedFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.materialPropertyVerified',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'pricePropertyReviewedFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.pricePropertyReviewed',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'priceMaintainedFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.priceMaintained',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mountedFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.mounted',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'routeMaintainedFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.routeMaintained',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'orderCodeFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.orderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'costEnteredFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.costEntered',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
        }
        },
    {
        key: 'createdByNameFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.createdByName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialPropertyCheckerFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.materialPropertyChecker',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'pricePropertyCheckerFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.pricePropertyChecker',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mountCheckerFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.mountChecker',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'routeMaintainCheckerFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.routeMaintainChecker',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'orderCodeCreatorFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.orderCodeCreator',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'costCheckerFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.costChecker',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialPropertyCheckedTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.materialPropertyCheckedTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialPropertyCheckedTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.materialPropertyCheckedTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'pricePropertyCheckedTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.pricePropertyCheckedTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'pricePropertyCheckedTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.pricePropertyCheckedTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mountCheckedTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.mountCheckedTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mountCheckedTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.mountCheckedTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'routeMaintainCheckedTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.routeMaintainCheckedTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'routeMaintainCheckedTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.routeMaintainCheckedTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'orderCodeCreateTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.orderCodeCreateTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'orderCodeCreateTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.orderCodeCreateTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'costCheckedTimeRteFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.costCheckedTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'costCheckedTimeLteFilter',
        label: 'label.sith.prd.sithMesPrdZpp1.filter.costCheckedTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'usage',
        label: 'label.sith.prd.sithMesPrdZpp1.entity.usage',
        sortable: true,
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'zpp1_workflow_usage'
                }
        },
        {
        key: 'machineType',
        label: 'label.sith.prd.sithMesPrdZpp1.entity.machineType',
        sortable: true,
        disabled: false,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'zpp1_workflow_machine_type'
                }
        },
        {
        key: 'number',
        label: 'label.sith.prd.sithMesPrdZpp1.entity.number',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'materialNumber',
        label: 'label.sith.prd.sithMesPrdZpp1.entity.materialNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'projectCode',
        label: 'label.sith.prd.sithMesPrdZpp1.entity.projectCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'hasMultipleBoms',
        label: 'label.sith.prd.sithMesPrdZpp1.entity.hasMultipleBoms',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdZpp1.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesPrdZpp1, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
